export default "__VITE_ASSET__0e064c56__$_?inline__"